<nz-spin [nzSpinning]="loading$ | async">
  <form
    nz-form
    class="form"
    nzLayout="horizontal"
    [formGroup]="preBipForm"
    (ngSubmit)="onSubmit()">
    <div class="drawer-form-wrapper">
      <div class="form-grid-secondary">
        <nz-form-item>
          <nz-form-label nzFor="selectStudent">Select Student</nz-form-label>
          <nz-form-control>
            <nz-input-group [nzSuffix]="suffixIconSearch" class="with-prefix">
              <input
                name="Search student"
                id="selectStudent"
                [nzAutocomplete]="auto"
                nz-input
                (input)="onSearchStudent($event)"
                (paste)="onSearchStudent($event)"
                (blur)="checkStudent()"
                formControlName="studentSearch"
                placeholder="Search student" />
            </nz-input-group>
            <nz-autocomplete #auto>
              <nz-auto-option
                *ngFor="let student of studentList"
                (click)="onSelect(student)"
                [nzValue]="student.firstName + ' ' + student.lastName"
                >{{
                  student.firstName +
                    ' ' +
                    student.lastName +
                    ' - ' +
                    student.enrollId
                }}</nz-auto-option
              >
              <nz-auto-option
                *ngIf="isStudentSearchLoading"
                [nzDisabled]="true">
                <span nz-icon nzType="loading" nzSpin></span> Loading...
              </nz-auto-option>
              <nz-auto-option
                *ngIf="
                  !isStudentSearchLoading &&
                  studentList.length === 0 &&
                  preBipForm.get('studentSearch')?.value
                "
                class="no-result-option"
                [nzDisabled]="true">
                No student found with this name
              </nz-auto-option>
            </nz-autocomplete>
            <ng-template #suffixIconSearch>
              <span nz-icon nzType="search"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="studentId" nzRequired>Student ID</nz-form-label>
          <nz-form-control [nzErrorTip]="studentIdErrorTpl">
            <input
              name="studentId"
              type="text"
              nz-input
              id="studentId"
              formControlName="studentId"
              placeholder="Student ID" />
            <ng-template #studentIdErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter your Student Id.
              </ng-container>
              <ng-container *ngIf="control.hasError('pattern')">
                Student Id only contain alphabets, digits, hyphens, and
                underscores.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="studentSchool" nzRequired
            >Student's School</nz-form-label
          >
          <nz-form-control nzErrorTip="Please select student's school.">
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select student's school"
              formControlName="organizationId"
              (nzOnSearch)="onSearchOrganization($event)"
              [nzNotFoundContent]="organizationNotFoundTemplate"
              name="organizationId">
              @for (org of organizationList; track org) {
                <nz-option
                  [nzLabel]="org.organizationName ?? org.value"
                  [nzValue]="org.id"></nz-option>
              }
            </nz-select>
            <ng-template #organizationNotFoundTemplate>
              <div *ngIf="isOrganizationSearchLoading" class="loading-content">
                <span nz-icon nzType="loading" nzSpin></span> Loading...
              </div>
              <div
                *ngIf="
                  !isOrganizationSearchLoading && organizationList.length === 0
                ">
                No schools found
              </div>
              <div
                *ngIf="
                  !isOrganizationSearchLoading && organizationList.length > 0
                ">
                No matching schools found
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="firstName" nzRequired>First Name</nz-form-label>
          <nz-form-control [nzErrorTip]="firstNameErrorTpl">
            <input
              name="first name"
              type="text"
              nz-input
              id="firstName"
              formControlName="firstName"
              placeholder="Enter first name" />
            <ng-template #firstNameErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter first name.
              </ng-container>
              <ng-container *ngIf="control.hasError('minlength')">
                First name must be at least 2 characters.
              </ng-container>
              <ng-container *ngIf="control.hasError('maxlength')">
                First name can not exceed 100 characters.
              </ng-container>
              <ng-container
                *ngIf="
                  control.hasError('pattern') &&
                  !control.hasError('minlength') &&
                  !control.hasError('maxlength')
                ">
                First name only contain alphabets and spaces.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="lastName" nzRequired>Last Name</nz-form-label>
          <nz-form-control [nzErrorTip]="lastNameErrorTpl">
            <input
              name="last name"
              type="text"
              nz-input
              id="lastName"
              formControlName="lastName"
              placeholder="Enter last name" />
            <ng-template #lastNameErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter your last name.
              </ng-container>
              <ng-container *ngIf="control.hasError('minlength')">
                Last name must be at least 2 characters.
              </ng-container>
              <ng-container *ngIf="control.hasError('maxlength')">
                Last name can not exceed 100 characters.
              </ng-container>
              <ng-container
                *ngIf="
                  control.hasError('pattern') &&
                  !control.hasError('minlength') &&
                  !control.hasError('maxlength')
                ">
                Last name only contain alphabets and spaces.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="dob" nzRequired>Date of Birth</nz-form-label>
          <nz-form-control nzErrorTip="Please select student's DOB">
            <nz-date-picker
              [nzSuffixIcon]="customSuffix"
              formControlName="dateOfBirth"
              nzFormat="MM/dd/yyyy"
              nzPlaceHolder="Select Date"
              [nzDisabledDate]="disabledDate"
              class="with-suffix"></nz-date-picker>
            <ng-template #customSuffix>
              <svg-icon
                [title]="'Select Date'"
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"></svg-icon>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="gender" nzRequired>Gender</nz-form-label>
          <nz-form-control nzErrorTip="Please select gender.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select gender"
              formControlName="genderId"
              name="gender"
              [nzNotFoundContent]="
                genderList.length === 0
                  ? 'No gender options available'
                  : 'No matching gender found'
              "
              [nzShowArrow]="true">
              @for (gender of genderList; track gender) {
                <nz-option
                  [nzLabel]="gender.value"
                  [nzValue]="gender.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="race" nzRequired>Race</nz-form-label>
          <nz-form-control nzErrorTip="Please select race.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select race"
              formControlName="raceId"
              name="race"
              [nzNotFoundContent]="
                raceList.length === 0
                  ? 'No race options available'
                  : 'No matching race found'
              "
              [nzShowArrow]="true">
              @for (race of raceList; track race) {
                <nz-option
                  [nzLabel]="race.value"
                  [nzValue]="race.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="generalEducation">
            General Education
          </nz-form-label>
          <nz-form-control nzErrorTip="Please select general education.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzMode="multiple"
              nzPlaceHolder="Select General Educations"
              name="generalEducations"
              formControlName="generalEducations"
              [nzNotFoundContent]="
                generalEducationList.length === 0
                  ? 'No general education options available'
                  : 'No matching options found'
              "
              [nzShowArrow]="true">
              @for (ge of generalEducationList; track ge) {
                <nz-option [nzLabel]="ge.value" [nzValue]="ge.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="specialEducation">
            Special Education
          </nz-form-label>
          <nz-form-control nzErrorTip="Please select special education.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzMode="multiple"
              nzPlaceHolder="Select Special Educations"
              formControlName="specialEducations"
              name="specialEducations"
              [nzNotFoundContent]="
                specialEducationList.length === 0
                  ? 'No special education options available'
                  : 'No matching options found'
              "
              [nzShowArrow]="true">
              @for (se of specialEducationList; track se) {
                <nz-option [nzLabel]="se.value" [nzValue]="se.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="bipTemplate" nzRequired
            >Behavior Category</nz-form-label
          >
          <nz-form-control nzErrorTip="Please select Behavior category.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Behavior Category"
              formControlName="caseBehaviorId"
              name="caseBehaviorId"
              [nzNotFoundContent]="behaviourCategoryNotFoundTemplate"
              [nzShowArrow]="true">
              @for (behaviour of behaviourList; track behaviour) {
                <nz-option
                  [nzLabel]="behaviour.value"
                  [nzValue]="behaviour.id"></nz-option>
              }
            </nz-select>
            <ng-template #behaviourCategoryNotFoundTemplate>
              <div *ngIf="behaviourList.length === 0">
                No behavior categories available
              </div>
              <div *ngIf="behaviourList.length > 0">
                No matching behavior categories found
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="caseBehaviorsType" nzRequired
            >Behavior Sub-Type</nz-form-label
          >
          <nz-form-control nzErrorTip="Please select Behavior sub-type.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Behavior sub-type"
              nzMode="multiple"
              formControlName="caseBehaviorsType"
              name="caseBehaviorsType"
              [nzNotFoundContent]="behaviourSubTypeNotFoundTemplate"
              [nzShowArrow]="true">
              @for (behaviour of behaviourSubTypeList; track behaviour) {
                <nz-option
                  [nzLabel]="behaviour.name"
                  [nzValue]="behaviour.id"></nz-option>
              }
            </nz-select>
            <ng-template #behaviourSubTypeNotFoundTemplate>
              <div *ngIf="isBehaviourSubTypeLoading" class="loading-content">
                <span nz-icon nzType="loading" nzSpin></span> Loading...
              </div>
              <div
                *ngIf="
                  !isBehaviourSubTypeLoading &&
                  behaviourSubTypeList.length === 0
                ">
                No behavior sub-types available
              </div>
              <div
                *ngIf="
                  !isBehaviourSubTypeLoading && behaviourSubTypeList.length > 0
                ">
                No matching sub-types found
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="customScheduleId" nzRequired
            >Student Schedule</nz-form-label
          >
          <nz-form-control nzErrorTip="Please select student schedule.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select student schedule"
              formControlName="customScheduleId"
              name="customScheduleId"
              [nzNotFoundContent]="scheduleNotFoundTemplate"
              [nzShowArrow]="true">
              @for (schedule of customScheduleList; track schedule) {
                <nz-option
                  [nzLabel]="schedule.templateName"
                  [nzValue]="schedule.customScheduleId"></nz-option>
              }
            </nz-select>
            <ng-template #scheduleNotFoundTemplate>
              <div *ngIf="isScheduleLoading" class="loading-content">
                <span nz-icon nzType="loading" nzSpin></span> Loading...
              </div>
              <div
                *ngIf="!isScheduleLoading && customScheduleList.length === 0">
                No schedule templates available
              </div>
              <div *ngIf="!isScheduleLoading && customScheduleList.length > 0">
                No matching schedules found
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="col-span">
          <nz-form-label nzFor="languageLevelId" nzRequired>
            <p class="form-desc">
              Select which of the following best describes the vocal language
              skills and ability of the student to understand spoken directions:
            </p>
          </nz-form-label>
          <div class="radio-wrapper">
            <nz-radio-group
              id="languageLevelId"
              nzName="radiogroup"
              formControlName="languageLevelId"
              class="case-option-wrapper">
              @for (lang of languageLevelList; track lang; let i = $index) {
                <span nz-radio [nzValue]="lang.id" *ngIf="i < 2">
                  {{
                    i === 0
                      ? 'This student is often unable to verbally express needs/wants or may not usually understand simple spoken directions'
                      : 'This student is usually able to verbally express needs/wants AND usually understand simple spoken directions'
                  }}
                </span>
              }
            </nz-radio-group>
          </div>
        </nz-form-item>
        <nz-form-item class="col-span">
          <nz-form-label nzFor="note"> Notes </nz-form-label>
          <nz-form-control [nzErrorTip]="noteErrorTpl">
            <textarea
              id="note"
              name="note"
              rows="4"
              nz-input
              formControlName="note"
              placeholder="Enter your text"></textarea>
            <div class="mt-3 remaining-text">
              {{ preBipForm.value.note ? preBipForm.value.note.length : 0 }} of
              500 characters used
            </div>
            <ng-template #noteErrorTpl let-control>
              <ng-container *ngIf="control.hasError('maxlength')">
                Note can not exceed 500 characters.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="trainingStudent"
            >Training Student</nz-form-label
          >
          <nz-form-control nzErrorTip="Please select training student.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzPlaceHolder="Select"
              name="trainingStudent"
              formControlName="isTrainingStudent"
              (ngModelChange)="onTrainingStudentChange($event)"
              [nzShowArrow]="true">
              <nz-option nzLabel="Yes" [nzValue]="true"></nz-option>
              <nz-option nzLabel="No" [nzValue]="false"></nz-option>
            </nz-select>
            <span class="hint-text">
              This student will be purged after 14 days
            </span>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="safetyPlan">{{
            needSafetyPlanLabel | reportLabel | async
          }}</nz-form-label>
          <nz-form-control nzErrorTip="Please select safety plan.">
            <nz-select
              nzShowArrow="true"
              nzSuffixIcon
              nzShowSearch
              nzPlaceHolder="Select"
              name="isEnabledSafetyPlan"
              formControlName="isEnabledSafetyPlan"
              [nzShowArrow]="true">
              <nz-option nzLabel="Yes" [nzValue]="true"></nz-option>
              <nz-option nzLabel="No" [nzValue]="false"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button type="button" nzType="default" (click)="closeDrawer()">
        Cancel
      </button>
      <button
        nz-button
        type="submit"
        nzType="primary"
        [disabled]="preBipForm.invalid"
        [nzLoading]="loading">
        Save
      </button>
    </div>
  </form>
</nz-spin>

<nz-modal
  [(nzVisible)]="isTrainingWarningVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="handleCancelTrainingWarning()">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-warning">
        <svg-icon src="/assets/icon/icon-info.svg" class="icon s-20"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Training Student Warning</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        If you select 'Yes' for Training Student, this case will be deleted in
        14 days. Please only select this option if this is a practice/training
        student.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <button
      type="button"
      nzBlock
      nz-button
      nzType="primary"
      class="btn btn-confirm"
      (click)="handleCancelTrainingWarning()">
      Confirm
    </button>
  </ng-template>
</nz-modal>
